import React, { useEffect, useState } from "react";

import { Grid } from "@mui/material";
import CustomTable from "../../../../Components/Table/CustomTable";
import RegistrationDetailsModal from "../Modal/RegistrationDetailsModal";
import actions from "../../../../ReduxStore/actions";
import { useDispatch, useSelector } from "react-redux";
import { setHeaderName, setSubHeaderName } from "../../../../ReduxStore/Slices/headerSlice";

const RegistrationPending = () => {
  const tableData = [
    {
      Name: "Vallarasu",
      Email: "valla@gmail.com",
      MobileNumber: "1232343444",
      UserType: "Financial Consultant",
      Status: "Pending",
    },
    {
      Name: "Pravin",
      Email: "pravin@gmail.com",
      MobileNumber: "98787687687",
      UserType: "Financial Consultant",
      Status: "Pending",
    },
    {
      Name: "Shahul",
      Email: "shahul@gmail.com",
      MobileNumber: "123322443543",
      UserType: "Financial Consultant",
      Status: "Pending",
    },
    {
      Name: "Ramesh",
      Email: "Ramesh@gmail.com",
      MobileNumber: "76575675664",
      UserType: "Financial Consultant",
      Status: "Pending",
    },
    {
      Name: "Sanjeev",
      Email: "Sanjeev@gmail.com",
      MobileNumber: "909878789709",
      UserType: "Financial Consultant",
      Status: "Pending",
    },
  ];
  const tableHeadData = [
    "S.No",
    "Name",
    "Email",
    "Mobile Number",
    "User Type",
    "Status",
  ];


 const dispatch=useDispatch()  
  const { getAllPendingCustomersWithCreator } = useSelector(
    (state) => state?.getAllPendingCustomersWithCreator
  );

  console.log(
    getAllPendingCustomersWithCreator?.data,
    "getAllPendingCustomersWithCreator"
  );

  const { approveCustomer } = useSelector((state) => state?.approveCustomer);

  const { managementRegisterForCustomer } = useSelector(
    (state) => state?.managementRegisterForCustomer
  );

  const { rejectCustomer } = useSelector((state) => state?.rejectCustomer);
  
  useEffect(() => {
    const fetchData = async () => {
      const data1 = {
        data: {},
        method: "get",
        apiName: `getAllPendingCustomersWithCreator`,
      };
      await dispatch(actions.GETALLPENDINGCUSTOMERSWITHCREATOR(data1));
    };
    fetchData();
  }, [dispatch,approveCustomer,rejectCustomer]);

  const [rowTableData, setRowTableData] = useState([
    {
      Name: "--",
      customer_id: "--",
      email: "--",
      phone: "--",
      role: "--",
      approval_status: "--",
    },
  ]);
  console.log(rowTableData,"rowTableDatarowTableData")

  useEffect(() => {
    const tempArr = [];
    console.log(getAllPendingCustomersWithCreator,'getAllPendingCustomersWithCreatorgetAllPendingCustomersWithCreator')

    getAllPendingCustomersWithCreator?.data?.map((data, index) => {
      return tempArr.push({
        Name: `${data?.first_name} ${data?.last_name}`,
        customer_id: data?.customer_id,
        email: data?.email,
        phone: data?.phone,
        role: data?.role === "customer" ? "Individual" : data?.role,
        approval_status:
          data?.approval_status?.charAt(0).toUpperCase() +
          data?.approval_status?.slice(1),
      });
    });
    setRowTableData(tempArr);
  }, [getAllPendingCustomersWithCreator]);

  React.useEffect(() => {
      dispatch(setHeaderName("Registration Approval"));
      dispatch(setSubHeaderName(""));
    }, [dispatch]);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sx={{ width: "100px" }}>
        <CustomTable
          tableData={rowTableData}
          title="Registration Approval"
          tableView="tableView"
          tableHeadData={tableHeadData}
          // dataCreate="dataCreate"
          showApproveButton={true}
          modalVeiwName={RegistrationDetailsModal}
          ModalViewComponent1="ModalViewComponent"
          modalViewHeadingName="User Detail"
          modalHeadingName="Registration Details"
        />
      </Grid>
    </Grid>
  );
};

export default RegistrationPending;
